module.exports = __webpack_public_path__ + "img/maestro.0294b6b5.svg";